import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-4\"><h4 class=\"text-gray-600\">Model Form</h4><div class=\"mt-4\"><div class=\"w-full max-w-sm overflow-hidden bg-white border rounded-md shadow-md\"><form><div class=\"flex items-center justify-between px-5 py-3 text-gray-700 border-b\"><h3 class=\"text-sm\">Add Category</h3><button><svg class=\"w-4 h-4\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M6 18L18 6M6 6l12 12\"></path></svg></button></div><div class=\"px-5 py-6 text-gray-700 bg-gray-200 border-b\"><label class=\"text-xs\">Name</label><div class=\"relative mt-2 rounded-md shadow-sm\"><span class=\"absolute inset-y-0 left-0 flex items-center pl-3 text-gray-600\"><svg class=\"w-6 h-6\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z\"></path></svg></span><input type=\"text\" class=\"w-full px-12 py-2 border-transparent rounded-md appearance-none focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500\"></div></div><div class=\"flex items-center justify-between px-5 py-3\"><button class=\"px-3 py-1 text-sm text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none\"> Cancel </button><button class=\"px-3 py-1 text-sm text-white bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none\"> Save </button></div></form></div></div></div>", 1)
const _hoisted_2 = { class: "mt-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-600" }, "Forms", -1)
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "p-6 bg-white rounded-md shadow-md" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold text-gray-700 capitalize" }, " Account settings ", -1)
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "grid grid-cols-1 gap-6 mt-4 sm:grid-cols-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-700",
  for: "username"
}, "Username", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-700",
  for: "emailAddress"
}, "Email Address", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-700",
  for: "password"
}, "Password", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-gray-700",
  for: "passwordConfirmation"
}, "Password Confirmation", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-end mt-4" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "px-4 py-2 text-gray-200 bg-gray-800 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-700" }, " Save ")
], -1)

import { ref } from 'vue'
import Breadcrumb from '../partials/AppBreadcrumb.vue'

interface User {
  username: string
  email: string
  password: string
  confirm: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const user = ref<User>({
  username: '',
  email: '',
  password: '',
  confirm: '',
})

const register = () => {
  const data = JSON.parse(JSON.stringify(user.value))
  console.log('Registered: ', data)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Breadcrumb, { breadcrumb: "Forms" }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("form", {
            onSubmit: _withModifiers(register, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  class: "w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500",
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.username) = $event))
                }, null, 512), [
                  [_vModelText, user.value.username]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  class: "w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500",
                  type: "email",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.email) = $event))
                }, null, 512), [
                  [_vModelText, user.value.email]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  class: "w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500",
                  type: "password",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.password) = $event))
                }, null, 512), [
                  [_vModelText, user.value.password]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  class: "w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500",
                  type: "password",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.confirm) = $event))
                }, null, 512), [
                  [_vModelText, user.value.confirm]
                ])
              ])
            ]),
            _hoisted_13
          ], 40, _hoisted_7)
        ])
      ])
    ])
  ]))
}
}

})